import { Events } from '../../../../../../FSM/shared/constants'
import { FSMTransitionsFNOLVehicleSE } from '../constants'

const {
  FLOW_MACHINE_ID,
  AUTH_BANK_ID,
  FNOL_CLAIMS,
  FNOL_CLAIMS_LIST,
  FNOL_WINDSHIELD_FLOW,
  FNOL_WINDSHIELD_START,
} = FSMTransitionsFNOLVehicleSE

export default {
  [FNOL_WINDSHIELD_FLOW]: {
    initial: FNOL_WINDSHIELD_START,
    states: {
      [FNOL_WINDSHIELD_START]: {
        on: {
          [Events.BACK]: { target: `#${FLOW_MACHINE_ID}.${FNOL_CLAIMS}.${FNOL_CLAIMS_LIST}` },
          [Events.SESSION_EXPIRED]: `#${FLOW_MACHINE_ID}.${AUTH_BANK_ID}`,
        },
      },
    },
  },
}
